import { Price } from 'src/types';

import { IProductCondition } from './types';

export const getCondition = (
  name: 'new' | 'used',
  count: number
): IProductCondition => {
  return {
    name,
    from: 0,
    to: 0,
    count,
  };
};

export const getConditions = (filteredOffers: Price[]): IProductCondition[] => {
  const usedOffers = filteredOffers.filter(x => x.condition !== 'new');
  const newOffers = filteredOffers.filter(x => x.condition === 'new');

  if (!usedOffers.length) {
    return [];
  }

  const conditionList: IProductCondition[] = [];

  conditionList.push(getCondition('new', newOffers.length));

  conditionList.push(getCondition('used', usedOffers.length));

  return conditionList;
};
